import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 22H3V20H21V22ZM23 18H1V2H23V18ZM16.3174 7.26855L13.4277 9.96484L11.2539 7.93555L10.5713 7.29883L9.88867 7.93555L6.31738 11.2686L5.58691 11.9512L6.95117 13.4131L7.68262 12.7314L10.5713 10.0342L12.7461 12.0645L13.4287 12.7012L14.1113 12.0645L17.6826 8.73145L18.4131 8.04883L17.0488 6.58691L16.3174 7.26855Z"}}]};

const ChartLineBoardFilled = Vue.extend<IconProps>({
  name: 'ChartLineBoardFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chart-line-board-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChartLineBoardFilled;
